module.exports = __webpack_public_path__ + "ef118af14bcb25cbe869947cc6ad6873.MP3";